import classNames from "classnames";
import InputWrapper from "../../../../../components/Input/InputWrapper";

const Date = ({ settings = {} }) => {
    return (
        <InputWrapper>
            <span className={classNames({"required": settings.required})}>{settings.title}</span>
            <div>
                {settings.inputType === "date" && <span className="date">mm/dd/yyyy</span>}
            </div>
            {settings.description && <p>{settings.description}</p>}
        </InputWrapper>
    )
};

export default Date;